import { createContext } from 'react';

import type { HotelsSearchControlsWrapperProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/HotelSearchControlsWrapperProps';

const HotelsPropsContext = createContext<
  HotelsSearchControlsWrapperProps | undefined
>(undefined);

export default HotelsPropsContext;
